import { PlatformSidebarItem } from "@aurem/components";
import { cn, Popover, useBoolean, useBreakpoints } from "@aurem/ui";
import { MoreHorizontalIcon } from "lucide-react";
import { useI18n } from "providers/I18nProvider";
import { useLocation } from "react-router-dom";
import { SidebarItemData } from "./";
import { ShowMoreContent } from "./ShowMoreContent";

type Props = {
  options: SidebarItemData[];
  onClose?: () => void;
};

export const ShowMoreDropdown = ({ options, onClose }: Props) => {
  const { t } = useI18n();
  const { pathname } = useLocation();
  const { isMobile } = useBreakpoints();

  const isActive = options.some((option) => pathname.includes(option.to));
  const {
    value: showDropdown,
    setValue: setShowDropdown,
    setFalse: closeDropdown,
  } = useBoolean(false);

  return (
    <Popover
      open={showDropdown}
      onOpenChange={setShowDropdown}
      content={
        <ShowMoreContent
          options={options}
          closeDropdown={closeDropdown}
          onClose={onClose}
        />
      }
      placement="right-end"
      contentClassName="p-0 rounded-xl"
      offset={{
        mainAxis: isMobile ? 36 : 13,
        crossAxis: 0,
      }}
    >
      <div
        className={cn(
          "flex flex-col w-full items-center gap-1 rounded-md cursor-pointer",
          "focus-visible:outline focus-visible:outline-white focus-visible:outline-offset-[2px]",
        )}
      >
        <PlatformSidebarItem
          icon={<MoreHorizontalIcon size={20} />}
          label={t("apps.admin.navBar.more")}
          isActive={isActive}
        />
      </div>
    </Popover>
  );
};
